import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'loading-popup',
  standalone: true,
  imports: [],
  templateUrl: './loading-popup.component.html',
  styleUrl: './loading-popup.component.css',
})
export class LoadingPopupComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string }) {}
}
